import React from 'react'
import Popup from '../../components/Popup'
import PackagesList from './PackagesList'

interface ActivePackagesPopupProps {
    onClose: () => void
    $store: any
    $commitToStore: (data: any) => void
    zIndex?: number
}

function ActivePackagesPopup({ onClose, $store, $commitToStore, zIndex }: ActivePackagesPopupProps) {
    return (
        <Popup onClose={onClose} maxWidth="800px" style={zIndex ? { zIndex } : undefined}>
            <div>
                <h3 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: '600' }}>
                    Активные пакеты
                </h3>
                <PackagesList $store={$store} $commitToStore={$commitToStore} />
            </div>
        </Popup>
    )
}

export default ActivePackagesPopup
